<template>
  <div id="modal" class="modal order_disp_modal" v-show="modalShown">
    <div class="modal-main modal-container" id="order_disp_modal">
      <div class="modal-header">表示項目</div>
      <div class="search_content">
        <ul v-if="isSketchList">
          <li v-for="(plan, index) in sketchList" :key="'plan' + index">
            <input type="checkbox" :id="'sl_' + index" @click="setCheck($event, dispForm.sketchCheckList, plan.code)"
                v-model="dispForm.sketchCheckList" :value="plan.code"/>
              <label :for="'sl_' + index">{{plan.label}}</label>
          </li>
        </ul>
        <ul v-if="isSalesList">
          <li v-for="(plan, index) in salesList" :key="'plan' + index">
            <input type="checkbox" :id="'sl_' + index" @click="setCheck($event, dispForm.salesCheckList, plan.code)"
                v-model="dispForm.salesCheckList" :value="plan.code"/>
              <label :for="'sl_' + index">{{plan.label}}</label>
          </li>
        </ul>
        <ul v-if="isConfirmedOrderList">
          <li v-for="(plan, index) in orderList" :key="'plan' + index">
            <input type="checkbox" :id="'sl_' + index" @click="setCheck($event, dispForm.orderCheckList, plan.code)"
                v-model="dispForm.orderCheckList" :value="plan.code"/>
              <label :for="'sl_' + index">{{plan.label}}</label>
          </li>
        </ul>
        <ul v-if="isOutputSheetList">
          <li v-for="(plan, index) in rotList" :key="'plan' + index">
            <input type="checkbox" :id="'sl_' + index" @click="setCheck($event, dispForm.rotCheckList, plan.code)"
                v-model="dispForm.rotCheckList" :value="plan.code"/>
              <label :for="'sl_' + index">{{plan.label}}</label>
          </li>
        </ul>
        <ul v-if="isManufactureList">
          <li v-for="(plan, index) in manufactureList" :key="'plan' + index">
            <input type="checkbox" :id="'sl_' + index" @click="setCheck($event, dispForm.manufactureCheckList, plan.code)"
                v-model="dispForm.manufactureCheckList" :value="plan.code"/>
              <label :for="'sl_' + index">{{plan.label}}</label>
          </li>
        </ul>
      </div>
        <div class="modal-footer">
          <button class="main_btn pos_left" @click="defaultDisp()">デフォルト</button>
          <button class="main_btn pos_right" @click="close()">閉じる</button>
          <button class="main_btn search_btn" @click="disp()">適用</button>
        </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ListDispModal',
  components: {
  },
  props: {
    isSketchList: Boolean,
    isSalesList: Boolean,
    isConfirmedOrderList: Boolean,
    isManufactureList: Boolean,
    isOutputSheetList: Boolean,
    refDispForm: Object,
    defaultDispForm: Object
  },
  data () {
    return {
      dispForm: {
        sketchCheckList: [],
        salesCheckList: [],
        orderCheckList: [],
        rotCheckList: [],
        manufactureCheckList: []
      },
      modalShown: false,
      sketchList: [
        {code: 0, label: 'ステータス'},
        {code: 1, label: 'サービス名'},
        {code: 2, label: '依頼日'},
        {code: 3, label: '発注会社名'},
        {code: 4, label: '発注者名'},
        {code: 5, label: '発注者ID'},
        {code: 6, label: '発注者コメント'},
        {code: 7, label: 'イメージ１'},
        {code: 8, label: 'イメージ２'},
        {code: 9, label: 'イメージ３'},
        {code: 10, label: 'イメージ４'},
        {code: 11, label: 'イメージ５'}
      ],
      salesList: [
        {code: 0, label: 'ステータス'},
        {code: 1, label: 'サービス名'},
        {code: 2, label: '確定納品日'},
        {code: 3, label: '納品希望日時'},
        {code: 4, label: '組立設置希望日１'},
        {code: 5, label: '組立設置希望日２'},
        {code: 6, label: '組立設置希望日３'},
        {code: 7, label: '注文日'},
        {code: 8, label: '見積日'},
        {code: 9, label: 'プランID'},
        {code: 10, label: 'プラン名'},
        {code: 11, label: '数量'},
        {code: 12, label: '発注会社名'},
        {code: 13, label: '発注者名'},
        {code: 14, label: '発注者ID'},
        {code: 15, label: 'カテゴリー'},
        {code: 16, label: 'シリーズ'},
        {code: 17, label: 'プラン回数'},
        {code: 18, label: 'コンバイン個数'},
        {code: 19, label: 'ユニット個数'},
        {code: 20, label: '注文番号'},
        {code: 21, label: '注文個別番号'},
        {code: 22, label: '物件名'},
        {code: 23, label: '営業コメント'},
        {code: 24, label: '金額'},
        {code: 25, label: '商品代金'},
        {code: 26, label: '単価'},
        {code: 27, label: '配送料'},
        {code: 28, label: '決済方法'},
        {code: 29, label: '納品先名'},
        {code: 30, label: '郵便番号'},
        {code: 31, label: '納品先住所'},
        {code: 32, label: '受取人氏名'},
        {code: 33, label: '受取人電話番号'},
        {code: 34, label: '配送時の連絡事項'},
        {code: 35, label: 'カスタム１'},
        {code: 36, label: 'カスタム２'},
        {code: 37, label: 'カスタム３'},
        {code: 38, label: 'カスタム４'},
        {code: 39, label: 'カスタム５'},
        {code: 40, label: 'カスタム６'},
        {code: 41, label: 'カスタム７'},
        {code: 42, label: 'カスタム８'},
        {code: 43, label: 'カスタム９'},
        {code: 44, label: 'カスタム１０'}
      ],
      orderList: [
        {code: 0, label: '計画ID'},
        {code: 1, label: 'ステータス'},
        {code: 2, label: 'サービス名'},
        {code: 3, label: '確定納品日'},
        {code: 4, label: '納品希望日時'},
        {code: 5, label: '組立設置希望日１'},
        {code: 6, label: '組立設置希望日２'},
        {code: 7, label: '組立設置希望日３'},
        {code: 8, label: 'プランID'},
        {code: 9, label: 'プラン名'},
        {code: 10, label: '物件名'},
        {code: 11, label: '発注会社名'},
        {code: 12, label: '発注者名'},
        {code: 13, label: '発注者ID'},
        {code: 14, label: 'コンバイン個数'},
        {code: 15, label: 'ユニット個数'},
        {code: 16, label: '注文番号'},
        {code: 17, label: '注文個別番号'},
        {code: 18, label: '営業コメント'},
        {code: 19, label: '受注時特記事項'},
        {code: 20, label: '金額'},
        {code: 21, label: '商品代金'},
        {code: 22, label: '単価'},
        {code: 23, label: '配送料'},
        {code: 24, label: '納品先名'},
        {code: 25, label: '郵便番号'},
        {code: 26, label: '納品先住所'},
        {code: 27, label: '受取人氏名'},
        {code: 28, label: '受取人電話番号'},
        {code: 29, label: '配送時の連絡事項'},
        {code: 30, label: 'カスタム１'},
        {code: 31, label: 'カスタム２'},
        {code: 32, label: 'カスタム３'},
        {code: 33, label: 'カスタム４'},
        {code: 34, label: 'カスタム５'},
        {code: 35, label: 'カスタム６'},
        {code: 36, label: 'カスタム７'},
        {code: 37, label: 'カスタム８'},
        {code: 38, label: 'カスタム９'},
        {code: 39, label: 'カスタム１０'}
      ],
      rotList: [
        {code: 0, label: 'ステータス'},
        {code: 1, label: '生産日'},
        {code: 2, label: '計画ID'},
        {code: 3, label: 'プラン個数'},
        {code: 4, label: 'コンバイン個数'},
        {code: 5, label: 'ユニット個数'},
        {code: 6, label: '金額'}
      ],
      manufactureList: [
        {code: 0, label: 'ステータス'},
        {code: 1, label: 'サービス名'},
        {code: 2, label: '納品完了日'},
        {code: 3, label: '出荷完了日'},
        {code: 4, label: '生産完了日'},
        {code: 5, label: '生産日'},
        {code: 6, label: '計画ID'},
        {code: 7, label: '確定納品日'},
        {code: 8, label: '納品希望日時'},
        {code: 9, label: '組立設置希望日１'},
        {code: 10, label: '組立設置希望日２'},
        {code: 11, label: '組立設置希望日３'},
        {code: 12, label: 'プランID'},
        {code: 13, label: 'プラン名'},
        {code: 14, label: '発注会社名'},
        {code: 15, label: '発注者名'},
        {code: 16, label: '発注者ID'},
        {code: 17, label: 'コンバイン個数'},
        {code: 18, label: 'ユニット個数'},
        {code: 19, label: '注文番号'},
        {code: 20, label: '注文個別番号'},
        {code: 21, label: '物件名'},
        {code: 22, label: '営業コメント'},
        {code: 23, label: '受注時特記事項'},
        {code: 24, label: '金額'},
        {code: 25, label: '商品代金'},
        {code: 26, label: '単価'},
        {code: 27, label: '配送料'},
        {code: 28, label: '決済方法'},
        {code: 29, label: '納品先名'},
        {code: 30, label: '郵便番号'},
        {code: 31, label: '納品先住所'},
        {code: 32, label: '受取人氏名'},
        {code: 33, label: '受取人電話番号'},
        {code: 34, label: '配送時の連絡事項'},
        {code: 35, label: 'カスタム１'},
        {code: 36, label: 'カスタム２'},
        {code: 37, label: 'カスタム３'},
        {code: 38, label: 'カスタム４'},
        {code: 39, label: 'カスタム５'},
        {code: 40, label: 'カスタム６'},
        {code: 41, label: 'カスタム７'},
        {code: 42, label: 'カスタム８'},
        {code: 43, label: 'カスタム９'},
        {code: 44, label: 'カスタム１０'}
      ]
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    disp: function () {
      this.modalShown = false
      this.$emit('onDisp', this.dispForm)
    },
    defaultDisp: function () {
      if (this.isSketchList) {
        this.dispForm.sketchCheckList = this.defaultDispForm.sketchCheckList
      } else if (this.isSalesList) {
        this.dispForm.salesCheckList = this.defaultDispForm.salesCheckList
      } else if (this.isConfirmedOrderList) {
        this.dispForm.orderCheckList = this.defaultDispForm.orderCheckList
      } else if (this.isOutputSheetList) {
        this.dispForm.rotCheckList = this.defaultDispForm.rotCheckList
      } else if (this.isManufactureList) {
        this.dispForm.manufactureCheckList = this.defaultDispForm.manufactureCheckList
      }
    },
    close: function () {
      this.modalShown = false
    },
    setCheck: function (event, checkList, code) {
      if (event.target.checked === true) {
        checkList.push(code)
      } else {
        checkList = checkList.filter(s => s !== code)
      }
    }
  },
  computed: {
  },
  mounted: function () {
  },
  created: function () {
    this.dispForm.sketchCheckList = Object.assign([], this.refDispForm.sketchCheckList)
    this.dispForm.salesCheckList = Object.assign([], this.refDispForm.salesCheckList)
    this.dispForm.orderCheckList = Object.assign([], this.refDispForm.orderCheckList)
    this.dispForm.rotCheckList = Object.assign([], this.refDispForm.rotCheckList)
    this.dispForm.manufactureCheckList = Object.assign([], this.refDispForm.manufactureCheckList)
  }
}
</script>

<style src="../../../css/order/order_search.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.modal-container {
  max-width: 30%;
}
input[type="checkbox"] + label {
  min-width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/ListDispModal.vue